import React from 'react';


/**
 * Per-dock payout badge glyph for the Orbital River. Each of a player's
 * four docks is identified by a regular-polygon primitive whose side
 * count is self-identifying (sides = dockIndex + 3): dock 0 = triangle,
 * dock 1 = square, dock 2 = pentagon, dock 3 = hexagon. This mirrors the
 * rulebook's Dock_Icon_1..4 art
 * (artwork_may_2026/17_rulebook_scribus_exports/Icons/) -- light-teal
 * fill, dark-teal border -- so no legend is needed. The Snohe the docked
 * guest would pay right now is overlaid as centered text.
 *
 * Sizing and positioning come from the className the caller passes in
 * (e.g. `tradelane-dock-payout`); this component only renders the glyph.
 *
 * Pattern mirrors CheckmarkIcon / FireIcon (the other river indicator
 * glyphs) so the indicator family reads as a matched set. Rendered as
 * inline SVG -- never the Dock_Icon PNGs. Michael may retune the exact
 * colors later; the structure (shape + centered value, one SVG, no PNG
 * assets) is the contract.
 */

const DOCK_FILL = '#74C7C0';
const DOCK_STROKE = '#0F5B55';
const DOCK_VALUE_COLOR = '#10312E';
const ICON_CENTER = 10;
const ICON_RADIUS = 8.4;


function regularPolygonPoints(sides, cx, cy, radius) {
    let points = [];
    // First vertex points straight up (-90 deg) so every shape reads
    // upright; step around the circle by a full turn / sides.
    for (let i = 0; i < sides; i++) {
        const angle = (-Math.PI / 2) + (i * 2 * Math.PI / sides);
        const x = cx + (radius * Math.cos(angle));
        const y = cy + (radius * Math.sin(angle));
        points.push(`${x.toFixed(2)},${y.toFixed(2)}`);
    }
    return points.join(' ');
}


export default function DockIcon({ dockIndex, value, className, style, title }) {
    const sides = dockIndex + 3;
    const points = regularPolygonPoints(sides, ICON_CENTER, ICON_CENTER, ICON_RADIUS);
    return (
        <svg className={className}
             style={style}
             viewBox="0 0 20 20"
             xmlns="http://www.w3.org/2000/svg"
             role={title ? 'img' : 'presentation'}
             aria-hidden={title ? undefined : true}>
            {title && <title>{title}</title>}
            <polygon
                points={points}
                fill={DOCK_FILL}
                stroke={DOCK_STROKE}
                strokeWidth="1.2"
                strokeLinejoin="round"
            />
            <text
                x={ICON_CENTER}
                y={ICON_CENTER}
                textAnchor="middle"
                dominantBaseline="central"
                fill={DOCK_VALUE_COLOR}
                fontSize="9"
                fontWeight="bold">
                {value}
            </text>
        </svg>
    );
}
